export default __webpack_public_path__ + "static/media/plus.5527a63d.png";